import { FormatBoldSharp } from '@mui/icons-material';
import { useActive, useCommands } from '@remirror/react';

import ButtonBase from './ButtonBase';

const ToggleBoldButton = () => {
  const { toggleBold, focus } = useCommands();
  const { bold } = useActive();

  const handleClick = () => {
    // Both are registered by `AiRemirror`'s extensions; the hook types every command as optional.
    toggleBold?.();
    focus?.();
  };

  return (
    <ButtonBase active={bold()} disabled={!toggleBold?.enabled()} onClick={handleClick}>
      <FormatBoldSharp />
    </ButtonBase>
  );
};

export default ToggleBoldButton;
